import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

const AboutHakan = () => {
  const { t } = useLang();
  const a = t.about;
  return (
    <section
      id="about-hakan"
      data-testid="about-hakan-section"
      className="py-20 md:py-32 border-t border-white/10 bg-[var(--hk-surface)]"
    >
      <div className="container-hk">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5"
          >
            <div className="relative aspect-[4/5] w-full max-w-md mx-auto lg:max-w-none">
              <div className="absolute -inset-2 md:-inset-3 border border-white/15" />
              <div className="absolute -bottom-3 -right-3 w-24 h-24 md:w-32 md:h-32 border-2 border-[var(--hk-red)]" />
              <div className="relative w-full h-full overflow-hidden bg-neutral-900">
                <img
                  src="/mr-hakan.jpg"
                  alt="Mr. Hakan"
                  data-testid="about-hakan-photo"
                  className="w-full h-full object-cover"
                  style={{ filter: "contrast(1.05) saturate(1.03)" }}
                />
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5 bg-gradient-to-t from-black via-black/70 to-transparent">
                  <div className="text-[10px] tracking-[0.35em] text-[var(--hk-red)] font-bold mb-1">
                    {a.badge}
                  </div>
                  <div className="font-display text-xl md:text-2xl tracking-[0.03em] text-white">
                    MR. HAKAN
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <div className="text-[10px] md:text-xs tracking-[0.35em] text-[var(--hk-red)] font-bold mb-3">
              // 002.5 · {a.overline}
            </div>
            <h2 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] tracking-tight mb-8">
              {a.title}
            </h2>
            <div className="space-y-5 text-sm md:text-[15px] text-white/75 leading-relaxed">
              {a.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <blockquote className="mt-10 border-l-2 border-[var(--hk-red)] pl-5 py-2">
              <p className="font-display text-lg md:text-2xl tracking-tight text-white italic leading-snug">
                “{a.quote}”
              </p>
            </blockquote>

            <p className="mt-6 text-sm text-white/60">{a.closing}</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutHakan;
